/*
  LIORIVE (QC 2026-10-11) — product page, from 990px: the buy column stays beside the photos instead of
  ending halfway down a long gallery. A column shorter than the screen holds under the top; a taller one
  first scrolls to its own end, then holds there (sticky top = the screen height minus its height).
*/
(() => {
  const mq = window.matchMedia('(min-width: 990px)');
  const col = document.querySelector('.product__info-container');
  if (!col) return;
  col.classList.add('lr-hold');
  const set = () => {
    if (!mq.matches) return col.style.removeProperty('--lr-hold-top');
    const top = Math.min(120, window.innerHeight - col.offsetHeight - 24);
    col.style.setProperty('--lr-hold-top', `${top}px`);
  };
  if ('ResizeObserver' in window) new ResizeObserver(set).observe(col);
  window.addEventListener('resize', set);
  set();
})();
